<template>
    <div>
        <div class="automation-trigger-settings">
            <p>
                {{ t('automations-form-triggers_config-feedback_received-description') }}
            </p>
        </div>

        <div class="field">
            <label :class="{ label: true, 'label-danger': !isValid() }"
                >{{ t('automations-form-triggers_config-feedback_received-form_label') }}</label
            >
            <select class="form-control" v-model="forms_id">
                <option
                    v-for="form in forms"
                    :key="form.id"
                    :value="form.id"
                    :selected="forms_id === form.id"
                >
                    {{ form.name }}
                </option>
            </select>
        </div>

        <div class="field">
            <label :class="{ label: true, 'label-danger': !isValid() }"
                >{{ t('automations-form-triggers_config-feedback_received-when_label') }}
            </label>
            <select v-model="filterType" class="form-control">
                <option value="all">{{ t('automations-form-triggers_config-feedback_received-when_options-all') }}</option>
                <option value="greater">{{ t('automations-form-triggers_config-feedback_received-when_options-greater') }}</option>
                <option value="lower">{{ t('automations-form-triggers_config-feedback_received-when_options-lower') }}</option>
            </select>
        </div>

        <div class="field" v-if="filterType !== 'all'">
            <label :class="{ label: true, 'label-danger': !isValid() }"
                >{{ t('automations-form-triggers_config-feedback_received-x_label') }}
            </label>
            <small v-if="filterType === 'greater'">
                {{ t('automations-form-triggers_config-feedback_received-greater_help') }}
            </small>
            <small v-if="filterType === 'lower'">
                {{ t('automations-form-triggers_config-feedback_received-lower_help') }}
            </small>
            <input type="text" v-model="filter" class="form-control" />
        </div>
    </div>
</template>
<script>
import keviApi from "./../../../keviApi";
let numbersOnly = (input) => {
    let result = String(input).replace(new RegExp("[^0-9.]", "g"), "");

    let firstDot = true;
    let dotReplacer = (match) => {
        if (firstDot === false) {
            return "";
        }
        firstDot = false;
        return match;
    };
    result = result.replace(new RegExp("[.]", "g"), dotReplacer);
    return result;
};
export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        let filterType =
            this.value.length > 0 && this.value[0].filterType
                ? this.value[0].filterType
                : "all";
        let filter =
            this.value.length > 0 && this.value[0].filter
                ? numbersOnly(this.value[0].filter)
                : null;
        return {
            filterType: filterType,
            filter: filter,
            forms: [],
            forms_id: null,
        };
    },
    mounted: function () {
        this.getForms();
        window.setTimeout(() => {
            this.changed();
        }, 100);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        isValid: function () {
            if (this.filterType === "all") {
                return true;
            }
            if (this.filterType === "greater" && parseFloat(this.filter) > 0) {
                return true;
            }
            if (this.filterType === "lower" && parseFloat(this.filter) > 0) {
                return true;
            }
            if (this.forms_id) {
                return true;
            }
            return false;
        },
        changed: function () {
            this.$emit("input", [
                {
                    filter: this.filter,
                    filterType: this.filterType,
                    forms_id: this.forms_id,
                },
            ]);
        },
        getForms() {
            this.forms = [];
            var options = keviApi.getOptions("forms");
            this.$http(options).then((response) => {
                if (response.status === 200) {
                    this.forms = [
                        ...response.body.filter((f) => f.questions?.length > 0),
                    ];
                    if (this.forms.length > 1) {
                        this.forms.unshift({
                            name: this.t('automations-form-triggers_config-feedback_received-all_forms'),
                            id: null,
                        });
                    }
                    if (this.forms.length == 1) {
                        this.forms_id = this.forms[0].id;
                    }
                }
            });
        },
    },
    watch: {
        filterType: function () {
            this.changed();
        },
        filter: function () {
            this.changed();
        },
        forms_id: function () {
            this.changed();
        },
        value: function () {
            let filterType =
                this.value.length > 0 && this.value[0].filterType
                    ? this.value[0].filterType
                    : "all";
            let filter =
                this.value.length > 0 && this.value[0].filter
                    ? numbersOnly(this.value[0].filter)
                    : null;
            let formsId =
                this.value.length > 0 && this.value[0].forms_id
                    ? this.value[0].forms_id
                    : null;
            if (filter !== this.filter) {
                this.filter = filter;
            }
            if (filterType !== this.filterType) {
                this.filterType = filterType;
            }
            if (formsId !== this.forms_id) {
                this.forms_id = formsId;
            }
        },
    },
};
</script>
